/*
 * <cart-sticky-checkout>
 * Reveals a fixed bottom checkout bar when the in-flow cart checkout button
 * (data-target) leaves the viewport, and hides it again when it is back in view.
 * Mirrors the theme's sticky-atc-bar IntersectionObserver pattern.
 * Lives inside #MainCart, so it is re-instantiated on each cart re-render
 * (connectedCallback re-observes the freshly rendered button).
 */
if (!customElements.get('cart-sticky-checkout')) {
  customElements.define(
    'cart-sticky-checkout',
    class CartStickyCheckout extends HTMLElement {
      connectedCallback() {
        const selector = this.getAttribute('data-target') || '.cart__checkout-btn';
        this.target = document.querySelector(selector);
        if (!this.target) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
